import {fetchFriends, fetchGameInfo, fetchProfile} from '@/shared/api/api';
import {makeAutoObservable, runInAction} from 'mobx';
import {IGameInfo, ILeague, IUser, leagueType} from '../types';
import {RootStore} from "@/app/providers/StoreProvider";

export class UserStore {

    constructor(private rootStore: RootStore) {
        makeAutoObservable(this);
    }

    private get errorStore() {
        return this.rootStore.errorStore;
    }

    private get modalStore() {
        return this.rootStore.modalStore;
    }
    // private get gameStore() {
    //     return this.rootStore.gameStore;
    // }
    private get inventoryStore() {
        return this.rootStore.inventoryStore;
    }

    user: IUser = {
        id: 0,
        firstName: '',
        lastName: '',
        username: '',
        photoUrl: '',
        score: 0,
    }
    gameInfo: IGameInfo = {
        user: {
            id: 0,
            energy: 0,
            dailyEnergy: 0,
            score: 0,
            totalShoots: 0,
            daysGameStreak: 0,
            currentStreak: 0,
            accurateRate: 0,
            wheel: 0,
            wheelRemainingTime: '',
            energyRemainingTime: '',
            goldenScore: 0,
            isNewUser: false,
            distribution: {
                isDistribution: false,
                endDistributionAt: ''
            },
            boughtItems: {},
        },
        hitStreak: 0,
        itemOptions: []
    }

    dailyEnergy:number = 0;

    referralLink: string = '';

    friends = 0;

    league: ILeague[] = [
        {
            from: 0,
            to: 300,
            text: 'Бронзовая лига',
            type: leagueType.Bronze
        },
        {
            from: 301,
            to: 600,
            text: 'Серебряная лига',
            type: leagueType.Silver
        },
        {
            from: 601,
            to: 999999999,
            text: 'Золотая лига',
            type: leagueType.Gold
        }
    ] as const

    loadingUser = false;

    initUser = async () => {
        this.loadingUser = true;
        try {
            if (this.user.id == 0) {
                const user = await fetchProfile();
                if (user.success) {
                    runInAction(() => {
                        this.user = user.data;
                    });
                } else {
                    this.errorStore.setError(user.error)
                }
            }
        } finally {
            runInAction(() => {
                this.loadingUser = false;
            });
        }
    }

    getGameInfo = async () => {
        this.loadingUser = true;
        try {
            const info = await fetchGameInfo();
            if (info.success) {
                runInAction(() => {
                    this.gameInfo = info.data;
                    this.dailyEnergy = info.data.user.dailyEnergy;

                    this.inventoryStore.activateConsumables(info.data.user.boughtItems);

                    if (this.gameInfo.user.isNewUser) {
                        this.modalStore.open('startPack', {});
                    }

                    //Раздача
                    // if (this.gameInfo.user.distribution.isDistribution &&
                    //     !dayjs(this.gameInfo.user.distribution.endDistributionAt).isBefore(dayjs())
                    //     ) {
                    //     //Не Очки а Жизни исправить
                    //     this.gameStore.addRawScore(50);
                    // }

                });
            } else {
                this.errorStore.setError(info.error)
            }
        } finally {
            runInAction(() => {
                this.loadingUser = false;
            });
        }
    }

    getFriends = async () => {
        this.loadingUser = true;
        try {
            const users = await fetchFriends();
            if (users.success) {
                runInAction(() => {
                    this.friends = users.data;
                });
            } else {
                this.errorStore.setError(users.error)
            }
        } finally {
            runInAction(() => {
                this.loadingUser = false;
            });
        }
    }


    decrementDailyEnergy = () => {
        if(this.dailyEnergy <=0) return;
        this.dailyEnergy--;
    }


}
